export default __webpack_public_path__ + "static/media/search_ico.eb168d06.svg";